<template>
    <div class="content">
        <section>
            <div class="content-box" style="text-align: start;">
                <HeaderBg :title="'CHECK'" :sub_title="'LotterY'" :desc="''" />

                <div class="mt-2 p-3">
                    <p class="mt-2" style="text-align: justify;">The way this game works is that players have to choose
                        a series of
                        numbers with 4 or
                        5
                        combinations.
                        Lucky numbers will be drawn on that day. Players will win if the set of player numbers purchased
                        matches one of the lucky numbers drawn. If the player Wants to verify the numbers against the
                        latest
                        EUROPE Lotto results, This handy Checker allows to compare the Player's numbers with the
                        official
                        EUROPE LOTTO results in a matter of seconds. Here's how:</p>

                    <p class="m-0 p-0">1. Select the game you want to check</p>
                    <p class="m-0 p-0">2. Click "Check Number"</p>
                    <p class="m-0 p-0">3. The examiner will confirm whether the Player has matched any numbers and won
                        any prizes.</p>

                    <p class="mt-3">*Click "Reset Number" to reinput the number</p>
                </div>


                <div class="text-center p-4">
                    <h5 class="fw-bold text-white bg-primary p-3 rounded">CHOOSE
                        YOUR NUMBER</h5>

                    <!-- Number Buttons -->
                    <div class="bg-light p-2 rounded mt-3">
                        <div class="d-flex justify-content-center">
                            <div v-for="digit in ['1', '2', '3', '4', '5']" :key="'top-' + digit"
                                class="result-ball mx-1" @click="selectNumber(digit)" style="cursor: pointer;">
                                <div class="p-1 result-ball-inside">{{ digit }}</div>
                            </div>
                        </div>
                        <br>
                        <div class="d-flex justify-content-center">
                            <div v-for="digit in ['6', '7', '8', '9', '0']" :key="'bottom-' + digit"
                                class="result-ball mx-1" @click="selectNumber(digit)" style="cursor: pointer;">
                                <div class="p-1 result-ball-inside">{{ digit }}</div>
                            </div>
                        </div>
                    </div>


                    <!-- Mode Selector -->
                    <div class="my-3">
                        <button v-for="type in ['3D', '4D', '5D']" :key="type" @click="setType(type)"
                            class="btn btn-sm mx-1 btn-warning"
                            :class="gameType === type ? 'btn-primary text-white' : 'btn-gold'">
                            {{ type }}
                        </button>
                    </div>

                    <!-- Selected Boxes -->
                    <div class="d-flex justify-content-center mb-3">
                        <div v-for="i in numberLength" :key="i" class="selected-box mx-2">
                            {{ selectedNumbers[i - 1] || '' }}
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="d-flex justify-content-center gap-2 mt-5">
                        <button class="btn btn-sm btn-warning fw-bold" @click="reset">RESET NUMBER</button>
                        <button class="btn btn-sm btn-warning fw-bold" @click="check">CHECK NUMBER</button>
                    </div>
                </div>

            </div>
        </section>
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-body">
                    <ResultDialog :visible="showModal" :selectedNumbers="selectedNumbers" :results="resultData"
                        @close="showModal = false" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderBg from './components/HeaderBg.vue';
import ResultDialog from './components/ResultDialog.vue';
import api from '@/axios'

export default {
    name: 'QuickPick',
    components: {
        HeaderBg,
        ResultDialog
    },
    data() {
        return {
            selectedNumbers: [],
            gameType: '3D',
            showModal: false,
            resultData: []
        }
    },
    computed: {
        numberLength() {
            return parseInt(this.gameType)
        }
    },
    methods: {
        selectNumber(num) {
            if (this.selectedNumbers.length < this.numberLength) {
                this.selectedNumbers.push(num)
            }
        },
        reset() {
            this.selectedNumbers = []
        },
        async check() {
            if (this.selectedNumbers.length !== this.numberLength) {
                alert(`Please select ${this.numberLength} digits`);
                return;
            }

            const number = this.selectedNumbers.join('');
            try {
                const res = await api.get(`/cek?type=${this.gameType}&number=${number}`);
                const data = res.data;

                this.resultData = data.data;
                this.showModal = true;
            } catch (e) {
                alert('Error checking number.');
                console.error(e);
            }
        },
        setType(type) {
            this.gameType = type;
            this.reset();
        }
    }

}
</script>

<style scoped>
.number-btn {
    width: 50px;
    height: 50px;
}

.selected-box {
    width: 60px;
    height: 60px;
    font-size: 24px;
    font-weight: bold;
    color: #1a3a7c;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #EAECF4;
    border-radius: 12px;
}
</style>